import { render, staticRenderFns } from "./ManuscriptPreviewPage.vue?vue&type=template&id=c4f8e1b6&scoped=true"
import script from "./ManuscriptPreviewPage.vue?vue&type=script&lang=ts"
export * from "./ManuscriptPreviewPage.vue?vue&type=script&lang=ts"
import style0 from "./ManuscriptPreviewPage.vue?vue&type=style&index=0&id=c4f8e1b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4f8e1b6",
  null
  
)

export default component.exports